<template>
  <v-row
    class="background-color-white z-index-2"
    :class="{ 'position-fixed': fixed }"
  >
    <v-col cols="12">
      <v-sheet :width="innerWidth">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide
            class="d-flex justify-center"
            v-for="(items, section) in menuItems"
            :key="section"
          >
            <v-btn
              :to="{
                name: 'menu',
                hash: `#${slug(section.replace(/^\d/, 'abc$&'))}`,
              }"
              @click="section === selectedSection && $store.commit('menu/RESET_PAGE')"
              class="no-uppercase"
              :class="{ 'active-side-nav': section === selectedSection }"
              rounded
              width="85"
              depressed
            >
              <h4
                class="font-weight-medium section-name-max-width text-truncate"
              >
                {{ section }}
              </h4>
            </v-btn>
          </swiper-slide>
        </swiper>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { slug } from 'github-slugger';

export default {
  name: 'XsMenuNavigation',
  computed: {
    ...mapGetters('menu', ['selectedSection']),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    window.addEventListener('resize', this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      swiperOptions: {
        slidesPerView: 3.2,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
    };
  },
  destroyed() {
    window.removeEventListener('resize', this.setInnerWidth);
  },
  methods: {
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    },
    slug,
  },
  props: { fixed: Boolean, menuItems: Object },
  watch: {
    selectedSection(val) {
      if (val && this.menuItems) {
        const index = Object.keys(this.menuItems).indexOf(val);
        if (index !== -1 && this.swiper) {
          this.swiper.slideTo(index);
        }
      }
    },
  },
};
</script>

<style scoped>
.active-side-nav {
  background-color: var(--v-primary-base) !important;
  color: var(--color-white) !important;
}

.position-fixed {
  position: fixed;
  top: 197px;
}

.section-name-max-width {
  max-width: 100px;
}

.z-index-2 {
  z-index: 2;
}
</style>
